export const messages = {
  backButton: {
    id: "session-notes-single-view.back",
    defaultMessage: "{{sessionTitle}} Notes",
  },
};
